import React from 'react';

const Announcement = ({title}) => {
    const announcement = [
        {
            name: "[Free JLPT N5 course] ",
            date: "[ From 05 Jan 2023] ",
            para: "We are starting a free demo japanese course for abosolute begineers."
        },
        {
            name: "[ Business Japanese course] ",
            date: "[ From 15 Jan 2023]",
            para: "New batch starting for Business Japanese students. Join early to get early bird offer."
        },
        {
            name: " [Get Job in Japan Meeting ]",
            date: "[On 30 Dec 2022]",
            para: 'We are holding a webnier on 30 December to explain "how to get job in Japan". Send us enquiry to join there for free.'
        }
    ]
    return (
        <div className=''>
            <h2 className=' text-2xl text-slate-400 font-semibold mb-5 border-b-2 border-cyan-500'>{title}</h2>
            <div className=' gap-5'>
                {
                    announcement.map((a, index) => <div key={index} className=' bg-slate-100 rounded p-3'>
                        <p>{a.date}</p>
                        <h3>{a.name}</h3>
                        <p>{a.para}</p>
                    </div>)
                }
            </div>
        </div>
    );
};

export default Announcement;